import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const BuyDexscreenerFire = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Buy Dexscreener Fire 🔥 - Hot Reaction Service | Dexreaction</title>
        <meta name="description" content="Buy Dexscreener Fire 🔥 reactions at the lowest price! Show your token is HOT and trending. Starting $0.05/fire. Instant delivery, 20% bonus free. #1 Dexscreener fire provider!" />
        <meta name="keywords" content="buy dexscreener fire, dexscreener fire, buy dexscreener reaction, buy dexscreener rockets, buy dexscreener poop, dexreactions, fire dexscreener, dexscreener fire emoji, hot dexscreener, buy fire reactions, cheap dexscreener fire" />
        <link rel="canonical" href="https://dexreaction.com/buy-dexscreener-fire" />
        <meta property="og:title" content="Buy Dexscreener Fire 🔥 - Hot Reaction Service | Dexreaction" />
        <meta property="og:description" content="Buy Dexscreener Fire from $0.05! Show your token is HOT. Instant delivery, 20% bonus!" />
        <meta property="og:image" content="https://dexreaction.com/og-image.png" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://dexreaction.com/buy-dexscreener-fire" />
        <link rel="sitemap" type="application/xml" href="/sitemap.xml" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-b from-slate-900 via-red-900/20 to-slate-900">
        {/* Header */}
        <nav className="fixed top-0 w-full bg-slate-900/80 backdrop-blur-md border-b border-red-500/20 z-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              <div className="flex items-center cursor-pointer" onClick={() => navigate('/')}>
                <img src="/logo-light.png" alt="Dexreaction" className="h-8" />
              </div>
              <button onClick={() => navigate('/')} className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors">
                Buy Fire Now
              </button>
            </div>
          </div>
        </nav>

        {/* Hero Section */}
        <section className="pt-32 pb-20 px-4">
          <div className="max-w-6xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 bg-red-500/20 text-red-300 px-6 py-3 rounded-full font-semibold mb-6">
              🔥 Your Token is ON FIRE!
            </div>
            <h1 className="text-5xl md:text-7xl font-bold mb-6">
              <span className="bg-gradient-to-r from-red-400 via-orange-400 to-yellow-400 bg-clip-text text-transparent">
                Buy Dexscreener Fire
              </span>
            </h1>
            <div className="text-8xl mb-6 animate-pulse">🔥</div>
            <p className="text-xl md:text-2xl text-gray-300 mb-4 max-w-3xl mx-auto">
              Show the World Your Token is HOT & Trending
            </p>
            <p className="text-lg text-gray-400 mb-8 max-w-2xl mx-auto">
              Fire 🔥 reactions signal that your token is heating up and attracting attention. Perfect for viral moments and high trading activity!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => navigate('/')}
                className="bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700 text-white px-10 py-4 rounded-lg font-bold text-xl transition-all transform hover:scale-105 inline-flex items-center gap-2"
              >
                🔥 Buy Dexscreener Fire
              </button>
              <button
                onClick={() => window.open('https://t.me/dexreactionrobot', '_blank')}
                className="bg-slate-800 hover:bg-slate-700 text-white px-10 py-4 rounded-lg font-bold text-xl transition-all border border-red-500/30"
              >
                Telegram Bot
              </button>
            </div>
          </div>
        </section>

        {/* Why Fire Reactions */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Why Buy Dexscreener Fire?
            </h2>
            <div className="grid md:grid-cols-3 gap-8">
              {[
                { icon: '🔥', title: 'HOT Signal', desc: 'Fire 🔥 shows your token is heating up and gaining massive attention in the market.' },
                { icon: '📈', title: 'Viral Indicator', desc: 'Perfect for viral campaigns, high volume days, and trending moments.' },
                { icon: '💫', title: 'Stand Out', desc: 'High fire counts make your token visually pop on DexScreener listings.' }
              ].map((item, idx) => (
                <div key={idx} className="bg-gradient-to-br from-red-900/30 to-orange-900/30 border border-red-500/20 rounded-xl p-6 text-center hover:border-red-500/50 transition-all">
                  <div className="text-5xl mb-4">{item.icon}</div>
                  <h3 className="text-xl font-bold mb-3">{item.title}</h3>
                  <p className="text-gray-400">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* When to Use Fire */}
        <section className="py-16 px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              When to Use Fire 🔥 Reactions
            </h2>
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-slate-800/50 border border-red-500/20 rounded-xl p-8">
                <h3 className="text-2xl font-bold mb-6 text-red-400">Perfect For:</h3>
                <ul className="space-y-4">
                  {[
                    '🎯 Viral marketing campaigns',
                    '📊 High volume trading days',
                    '🎉 Major announcements',
                    '💥 Trending moments',
                    '🌟 Token launch hype',
                    '📈 Price pump moments'
                  ].map((item, idx) => (
                    <li key={idx} className="flex items-center gap-3 text-gray-300">
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="bg-gradient-to-br from-red-500/10 to-orange-500/10 border-2 border-red-500/30 rounded-xl p-8">
                <h3 className="text-2xl font-bold mb-6">Fire vs Rocket</h3>
                <div className="space-y-4">
                  <div className="bg-slate-900/50 rounded-lg p-4">
                    <div className="flex items-center gap-3 mb-2">
                      <span className="text-3xl">🔥</span>
                      <span className="font-bold text-red-400">Fire</span>
                    </div>
                    <p className="text-sm text-gray-400">Best for: Hot moments, viral campaigns, high activity</p>
                  </div>
                  <div className="bg-slate-900/50 rounded-lg p-4">
                    <div className="flex items-center gap-3 mb-2">
                      <span className="text-3xl">🚀</span>
                      <span className="font-bold text-orange-400">Rocket</span>
                    </div>
                    <p className="text-sm text-gray-400">Best for: Bullish signals, upward momentum, launches</p>
                  </div>
                </div>
                <p className="mt-4 text-sm text-gray-400">💡 Tip: Use both for maximum impact!</p>
              </div>
            </div>
          </div>
        </section>

        {/* Pricing */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
              Dexscreener Fire Pricing
            </h2>
            <p className="text-center text-gray-400 mb-12 text-lg">
              $0.05 per fire reaction + 20% Bonus FREE
            </p>
            <div className="grid md:grid-cols-4 gap-6">
              {[
                { qty: 500, price: 25, total: 600 },
                { qty: 1000, price: 50, total: 1200, popular: true },
                { qty: 1500, price: 75, total: 1800 },
                { qty: 2000, price: 100, total: 2400 }
              ].map((pkg) => (
                <div key={pkg.qty} className={`relative bg-gradient-to-br from-red-900/30 to-orange-900/30 border-2 ${pkg.popular ? 'border-red-500' : 'border-red-500/30'} rounded-xl p-6 hover:border-red-500 transition-all`}>
                  {pkg.popular && (
                    <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                      <span className="bg-gradient-to-r from-red-600 to-orange-600 text-white px-4 py-1 rounded-full text-sm font-bold">Most Popular</span>
                    </div>
                  )}
                  <div className="text-center">
                    <div className="text-4xl mb-2">🔥</div>
                    <div className="text-3xl font-bold mb-2">{pkg.qty}</div>
                    <div className="text-gray-400 mb-4">Fire Reactions</div>
                    <div className="text-4xl font-bold text-red-400 mb-2">${pkg.price}</div>
                    <div className="bg-green-500/20 rounded-lg p-2 mb-4">
                      <span className="text-green-400 font-semibold">Get {pkg.total} total</span>
                    </div>
                    <button
                      onClick={() => navigate('/')}
                      className="w-full bg-red-600 hover:bg-red-700 text-white py-3 rounded-lg font-semibold transition-colors"
                    >
                      Buy Fire
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-16 px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Dexscreener Fire FAQ
            </h2>
            <div className="space-y-4">
              {[
                { q: 'What does fire 🔥 mean on DexScreener?', a: 'Fire reactions indicate that a token is "hot" - generating lots of attention and trading activity. It\'s one of the most visually impactful reactions.' },
                { q: 'When should I buy fire vs rocket?', a: 'Use fire for viral moments, high volume days, and when you want to show your token is trending. Use rockets for bullish momentum and launches.' },
                { q: 'How fast are fire reactions delivered?', a: 'Delivery starts immediately. We deliver 500 fire reactions every 10 minutes for natural-looking growth.' },
                { q: 'Can I buy both fire and rockets?', a: 'Yes! Many successful tokens use both. Place separate orders for each reaction type to maximize visibility.' }
              ].map((faq, idx) => (
                <div key={idx} className="bg-slate-800/50 border border-red-500/20 rounded-xl p-6">
                  <h3 className="text-lg font-bold mb-2 text-red-400">{faq.q}</h3>
                  <p className="text-gray-400">{faq.a}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-20 px-4 bg-gradient-to-r from-red-900/30 to-orange-900/30">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Make Your Token HOT! 🔥
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Buy Dexscreener Fire reactions and show the world your token is trending
            </p>
            <button
              onClick={() => navigate('/')}
              className="bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700 text-white px-12 py-4 rounded-lg font-bold text-xl transition-all transform hover:scale-105"
            >
              🔥 Buy Dexscreener Fire Now
            </button>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-slate-900 border-t border-red-500/20 py-8 px-4">
          <div className="max-w-6xl mx-auto text-center text-gray-400">
            <p>&copy; 2025 Dexreaction. All rights reserved.</p>
            <div className="mt-4 space-x-4">
              <button onClick={() => navigate('/terms')} className="hover:text-red-400 transition-colors">Terms</button>
              <button onClick={() => navigate('/privacy')} className="hover:text-red-400 transition-colors">Privacy</button>
              <button onClick={() => navigate('/')} className="hover:text-red-400 transition-colors">Contact</button>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default BuyDexscreenerFire;
